module.exports = __webpack_public_path__ + "static/media/secureShare.f454b8b8.png";